import React from 'react';
import ReactLoading from 'react-loading';


const SaveLoader = ({ type, color, height }) => (
    <div className="save-loader" >
        <ReactLoading type={type} color={color} height={120} width={120} className="page-loader" />
    </div>
);

export default SaveLoader;



// WEBPACK FOOTER //
// ./src/components/loader/SaveLoader.js